(function($){
    "use strict";

    console.log('custom script loaded.');

    $(document).ready( function(){
        var logo_margin_top = $('.announcement').height();
        $('.fixed_logo').css({
            'top': logo_margin_top,
            'margin-top': '10px'
        });
    });
  
    function _filterThumbnails (variant_value) {
      /**
       * Trigger event when variant image changes
       */
      $(document).on('variantImageSelected', '.gallery', function(e, data){
        if(data.featured_image != null && variant_value != null) {
          $('[data-thumbnail-color]').hide();
          // show thumbnails for selected color
          // [data-thumbnail-color="red"]

          var selected_color = variant_value;
          var thumbnail_selector = '[data-thumbnail-color]="' + selected_color + '"]';
          $(thumbnail_selector).show();
        } else {
          $('[data-thumbnail-color]').show();
        }
      });
    }

})(jQuery);